module.exports = __webpack_public_path__ + "fonts/BebasNeue Regular.28460981.otf";